import { render, staticRenderFns } from "./cuota.vue?vue&type=template&id=625b5f30&"
import script from "./cuota.component.ts?vue&type=script&lang=ts&"
export * from "./cuota.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports